import * as actionTypes from '../actions/actionTypes'
import {updateObject} from '../../helpers/utilities'

const initialState = {
  feedbacks: [],
  feedback: {
    name: '',
    email: '',
    feedbacktype: '',
    subject: '',
    description: ''
  },
  id: null,
  dialog_id: null,
  saving: false,
  error: null,
  loading: false,
  feedback_dialog_open: false
}

const addFeedbackStart = (state, action) => {
  return updateObject(state, {saving: true})
}

const addFeedbackSuccess = ( state, action ) => {
  return updateObject( state, {
      loading: false,
      saving: false,
      id: action.id
  } );
};

const addFeedbackFail = (state, action) => {
  return updateObject(state, {saving: false})
}

const initializeAddFeedback = (state, action) => {
  return updateObject(state, {
    feedback_dialog_open: false,
    feedback: {
      name: '',
      email: '',
      feedbacktype: '',
      subject: '',
      description: ''
    },
    feedbacks: [],
    id: null,
    dialog_id: null,
    loading: false,
    saving: false
  })
}

const openFeedbackDialog = (state, action) => {
    return updateObject(state, {
        feedback_dialog_open: true,
        dialog_id: action.id
    })
}

const closeFeedbackDialog = (state, action) => {
    return updateObject(state, {
        feedback_dialog_open: false
    })
}

const reducer = (state = initialState, action) => {
  switch(action.type){
    case actionTypes.ADD_FEEDBACK_START:
      return addFeedbackStart(state, action)
    case actionTypes.ADD_FEEDBACK_SUCCESS:
      return addFeedbackSuccess(state, action)
    case actionTypes.ADD_FEEDBACK_FAIL:
      return addFeedbackFail(state, action)
    case actionTypes.INITIALIZE_ADD_FEEDBACK:
      return initializeAddFeedback(state, action)
    case actionTypes.OPEN_FEEDBACK_DIALOG:
    return openFeedbackDialog(state, action)
    case actionTypes.CLOSE_FEEDBACK_DIALOG:
    return closeFeedbackDialog(state, action)
    default:
      return state
  }
}
    
export default reducer
